<template>
  <main class="imprint-page">
    <header class="site-header">
      <img
        class="site-logo"
        :src="logo"
        alt="BOTTIMMO Turkoglu"
      />
    </header>

    <section class="hero">
      <h1>{{ $t('impressum.title') }}</h1>
    </section>

    <section class="content">
      <div class="content-container">
        <section class="legal-section">
          <h2>{{ $t('impressum.section-one.title') }}</h2>

          <p>
            {{ $t('impressum.section-one.content.0') }}<br />
            {{ $t('impressum.section-one.content.1') }}<br />
            {{ $t('impressum.section-one.content.2') }}<br />
            {{ $t('impressum.section-one.content.3') }}<br />
            {{ $t('impressum.section-one.content.4') }}
            <a href="mailto:turkiye@immoviewer.com"> turkiye@immoviewer.com </a>
          </p>
        </section>

        <section class="legal-section">
          <h2>{{ $t('impressum.section-two.title') }}</h2>

          <p class="strong">
            {{ $t('impressum.section-two.content.0') }}
          </p>
        </section>

        <section class="legal-section">
          <h2>{{ $t('impressum.section-three.title') }}</h2>

          <p>
            {{ $t('impressum.section-three.content.0') }}<br />
            {{ $t('impressum.section-three.content.1') }}<br />
            {{ $t('impressum.section-three.content.2') }}
          </p>
        </section>

        <section class="legal-section">
          <h2>{{ $t('impressum.section-four.title') }}</h2>

          <p>
            {{ $t('impressum.section-four.content.0') }}
            <br />
            {{ $t('impressum.section-four.content.1') }}<br />
            {{ $t('impressum.section-four.content.2') }}
          </p>
        </section>

        <section class="legal-section">
          <h2>{{ $t('impressum.section-five.title') }}</h2>

          <p>
            {{ $t('impressum.section-five.content.0') }}
            {{ $t('impressum.section-five.content.1') }}
            {{ $t('impressum.section-five.content.2') }}
          </p>

          <p>
            {{ $t('impressum.section-five.content.3') }}
          </p>

          <p>
            {{ $t('impressum.section-five.content.4') }}
          </p>
        </section>

        <section class="legal-section">
          <h2>{{ $t('impressum.section-six.title') }}</h2>

          <p>
            {{ $t('impressum.section-six.content.0') }}
          </p>
        </section>

        <section class="legal-section">
          <h2>{{ $t('impressum.section-seven.title') }}</h2>

          <p>
            {{ $t('impressum.section-seven.content.0') }}
          </p>
        </section>

        <section class="image-credits">
          <strong>{{ $t('impressum.section-eight.title') }}</strong>

          <p>
            {{ $t('impressum.section-eight.content.0') }}
            <a
              href="https://unsplash.com/@jipy32?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jean-Philippe Delberghe </a
            >,
            <a
              href="https://unsplash.com/de/fotos/75xPHEQBmvA?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('impressum.section-eight.content.1') }}
            </a>

            {{ $t('impressum.section-eight.content.2') }}
          </p>

          <p>
            {{ $t('impressum.section-eight.content.0') }}
            <a
              href="https://unsplash.com/de/@_debs_"
              target="_blank"
              rel="noopener noreferrer"
            >
              Debora Pilati </a
            >,
            <a
              href="https://unsplash.com/de/s/fotos/waves-abstract?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('impressum.section-eight.content.1') }}
            </a>
            {{ $t('impressum.section-eight.content.2') }}
          </p>

          <p>
            {{ $t('impressum.section-eight.content.0') }}
            <a
              href="https://unsplash.com/de/@roguewild"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mike U </a
            >,
            <a
              href="https://unsplash.com/de/s/fotos/waves-abstract?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('impressum.section-eight.content.1') }}
            </a>
            {{ $t('impressum.section-eight.content.2') }}
          </p>
        </section>
      </div>
    </section>

    <footer class="site-footer">
      <div class="footer-container">
        <div class="footer-links">
          <strong>{{ $t('impressum.section-footer.title') }}</strong>

          {{ $t('impressum.section-footer.content.0') }}
          <span>{{ $t('impressum.section-footer.content.1') }}</span>

          <a
            target="_blank"
            :href="publicDataPrivacyUrl"
            rel="noopener noreferrer"
            >{{ $t('impressum.section-footer.content.2') }}</a
          >
        </div>

        <div class="footer-divider" />

        <div class="footer-company">
          © {{ currentYear }} {{ $t('impressum.section-footer.content.3') }}
          <span class="separator">·</span>
          {{ $t('impressum.section-footer.content.4') }}
          <br />
          {{ $t('impressum.section-footer.content.5') }}
        </div>
      </div>
    </footer>
  </main>
</template>

<script setup>
import { computed } from 'vue'

import logo from '@/assets/img/logo.png'
import { useBranding } from '@/composables/useBranding'
const currentYear = computed(() => new Date().getFullYear())
const { publicDataPrivacyUrl } = useBranding()
</script>

<style scoped>
.imprint-page {
  min-height: 100vh;
  background: #fff;
  color: #303030;
  font-family: Inter, Arial, Helvetica, sans-serif;
}

.site-header {
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-top: 1px solid #e5e5e5;
}

.site-logo {
  display: block;
  width: 300px;
  max-width: 70%;
  max-height: 58px;
  object-fit: contain;
}

.hero {
  min-height: 400px;
  background: #00150d;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
}

.hero h1 {
  margin: 0;
  color: #fff;
  font-size: clamp(40px, 4vw, 64px);
  font-weight: 700;
  line-height: 1.1;
}

.content {
  width: 100%;
}

.content-container {
  width: min(100% - 80px, 1240px);
  margin: 0 auto;
  padding: 38px 0 42px;
}

.legal-section {
  margin-bottom: 26px;
}

.legal-section h2 {
  margin: 0 0 14px;
  text-align: center;
  color: #303030;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.legal-section p {
  margin: 0 0 16px;
  color: #8d8d8d;
  font-size: 24px;
  line-height: 1.48;
}

.legal-section .strong {
  font-weight: 700;
}

.content a {
  color: inherit;
  text-decoration: none;
}

.content a:hover {
  text-decoration: underline;
}

.image-credits {
  margin-top: 38px;
  color: #8d8d8d;
  font-size: 24px;
  line-height: 1.48;
}

.image-credits strong {
  display: block;
  margin-bottom: 2px;
}

.image-credits p {
  margin: 0;
}

.site-footer {
  width: 100%;
  border-top: 1px solid #ededed;
  background: #fff;
}

.footer-container {
  width: min(100% - 80px, 1120px);
  margin: 0 auto;
  padding: 56px 0 32px;
}

.footer-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  font-size: 20px;
  line-height: 1.35;
}

.footer-links strong {
  font-weight: 700;
}

.footer-links a {
  color: inherit;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-divider {
  height: 1px;
  width: 100%;
  background: #e5e5e5;
  margin: 42px 0 28px;
}

.footer-company {
  color: #696969;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
}

.separator {
  display: inline-block;
  padding: 0 8px;
}

@media (max-width: 900px) {
  .site-header {
    height: 72px;
  }

  .site-logo {
    width: 240px;
  }

  .hero {
    min-height: 300px;
  }

  .content-container {
    width: min(100% - 48px, 1240px);
    padding-top: 34px;
  }

  .legal-section h2 {
    font-size: 24px;
  }

  .legal-section p,
  .image-credits {
    font-size: 19px;
  }

  .footer-container {
    width: min(100% - 48px, 1120px);
  }
}

@media (max-width: 600px) {
  .site-header {
    height: 64px;
    padding: 10px 16px;
  }

  .site-logo {
    width: 200px;
  }

  .hero {
    min-height: 220px;
    padding: 40px 20px;
  }

  .hero h1 {
    font-size: 36px;
  }

  .content-container {
    width: calc(100% - 32px);
    padding: 28px 0 32px;
  }

  .legal-section {
    margin-bottom: 24px;
  }

  .legal-section h2 {
    margin-bottom: 10px;
    font-size: 21px;
  }

  .legal-section p,
  .image-credits {
    font-size: 17px;
    line-height: 1.5;
  }

  .footer-container {
    width: calc(100% - 32px);
    padding: 40px 0 24px;
  }

  .footer-links {
    font-size: 17px;
  }

  .footer-divider {
    margin: 32px 0 22px;
  }

  .footer-company {
    font-size: 14px;
  }

  .separator {
    padding: 0 4px;
  }
}
</style>
